// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2lTML","approved":"Status_approved__3dgOo","rejected":"Status_rejected__1JKZL","expired":"Status_expired__u_dhx","label":"Status_label__3jOBd"};